<template>
    <login
        :on-close-success-modal="resetState"
        :on-login="login"
        :registered-email="registeredEmail"
        :demo-accessed="demoAccessed"
    />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Login from './Login';

export default {
    name: 'login-container',
    components: {
        Login,
    },
    methods: {
        ...mapActions('auth', ['login', 'resetState']),
    },
    computed: {
        ...mapGetters('auth', ['registeredEmail']),
    },
    destroyed() {
        this.resetState();
    }
}
</script>



// WEBPACK FOOTER //
// LoginContainer.vue?b686ed96